import { render, staticRenderFns } from "./RespiratoryCoordination.vue?vue&type=template&id=2b4abfc8&scoped=true&"
import script from "./RespiratoryCoordination.vue?vue&type=script&lang=js&"
export * from "./RespiratoryCoordination.vue?vue&type=script&lang=js&"
import style0 from "./RespiratoryCoordination.vue?vue&type=style&index=0&id=2b4abfc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4abfc8",
  null
  
)

export default component.exports